import { dynamic } from '#/utils/dynamic';

export const DynamicFixedStaffTools = dynamic(
  () =>
    import('./FixedStaffTools').then((module) => ({
      default: module.FixedStaffTools,
    })),
  { strategy: 'always' },
);
